import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { logger } from "@/utils/logger";

export function useAvailableLetters(isAdmin: boolean, isAdminLoading: boolean) {
  const { toast } = useToast();

  return useQuery({
    queryKey: ["available-letters", isAdmin],
    queryFn: async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          toast({
            variant: "destructive",
            title: "Não autenticado",
            description: "Por favor, faça login para continuar."
          });
          return [];
        }
        
        const today = new Date().toISOString().split('T')[0];

        let query = supabase
          .from("letters_with_owner")
          .select("*")
          .lte("delivery_date", today) // Lógica corrigida: usa a data
          .eq("payment_status", "paid")
          .order("delivery_date", { ascending: false });

        if (!isAdmin) {
          query = query.eq("user_id", session.user.id);
        }

        const { data, error } = await query;

        if (error) {
          logger.error("Erro ao buscar cartas disponíveis:", error);
          toast({
            variant: "destructive",
            title: "Erro ao buscar cartas",
            description: "Não foi possível carregar as cartas disponíveis."
          });
          return [];
        }
        
        return data || [];
      } catch (error) {
        logger.error("Erro na consulta:", error);
        toast({
          variant: "destructive",
          title: "Erro ao buscar cartas",
          description: "Ocorreu um erro ao tentar carregar as cartas disponíveis."
        });
        return [];
      }
    },
    enabled: !isAdminLoading,
  });
}